import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromRaffleLot from './raffle-lot.reducer'
import { RaffleLotEffects } from './raffle-lot.effects'
import { RaffleLotService } from './raffle-lot.service'
import { RaffleLotSerializer } from './raffle-lot.serializer'

@NgModule({
    imports: [
        SharedModule,
        StoreModule.forFeature(fromRaffleLot.FEATURE_NAME, fromRaffleLot.raffleLotReducer),
        EffectsModule.forFeature([RaffleLotEffects])
    ],
    declarations: [],
    exports: [],
    providers: [
        RaffleLotService,
        {
            provide: RaffleLotSerializer,
            useClass: RaffleLotSerializer
        }
    ]
})
export class RaffleLotModule {}
